import * as React from 'react'
import { UploadTeamLogoButtonConnected } from './UploadTeamLogoButtonConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UploadTeamLogoButtonExamples = () => {
  return (
    <div className="UploadTeamLogoButtonExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UploadTeamLogoButtonConnected />
      </Provider>
    </div>
  )
}
